import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/Layout"
import PageHeader from "../components/sections/PageHeader"
import Comments from "../components/sections/Comments"
import PostContent from "../components/sections/PostContent"
import Contact from "../components/sections/Contact"
import BlogSimilares from "../components/sections/BlogSimilares"

const PostItem = props => {
  const post = props.data.markdownRemark

  return (
    <Layout
      location={props.location}
      seo={{
        title: post.frontmatter.title,
        description: post.frontmatter.description,
        image: post.frontmatter.image.publicURL,
      }}
    >
      <PageHeader
        title={post.frontmatter.title}
        category={post.frontmatter.category}
        size={`sm`}
        customBg={post.frontmatter.image.publicURL}
      />

      <PostContent
        title={post.frontmatter.title}
        date={post.frontmatter.date}
        description={post.frontmatter.description}
        timeToRead={post.timeToRead}
        html={post.html}
      />

      <Comments
        url={post.fields.slug}
        title={post.frontmatter.title}
        category="posts"
      ></Comments>

      <BlogSimilares />
      <Contact variant={`sm`} />
    </Layout>
  )
}

export const query = graphql`
  query Post($slug: String) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      fields {
        slug
      }
      frontmatter {
        title
        category
        image {
          publicURL
        }
        description
        date(locale: "pt-br", formatString: "DD [de] MMMM [de] YYYY")
      }
    }
  }
`

export default PostItem
